import { css, keyframes } from "@emotion/react"
import { above } from "@mkt/cp/src/styles/Breakpoints"
import { colors } from "@mkt/ui/styles/Tokens"
import { colorsCP } from "@mkt/cp/src/styles/Tokens"

const SlideTop = keyframes`
  0% {
		transform: translateY(-100px);
		opacity: 0;
	}

	100% {
		transform: translateY(0);
		opacity: 1;
	}
`
const AnimationBar = keyframes`
  0% {
    background-position: 0 0;
  }

  50% {
    background-position: 25px 0;
  }

  100% {
    background-position: 57px 0;
  }
`

export const LoaderRedirect = css`
  position: fixed;
  z-index: 10;
  left: 0;
  right: 0;
  height: 100vh;
  width: 100%;
  display: flex;
  padding: 16px;
  align-items: center;
  justify-content: center;
  top: 100%;
  opacity: 0;

  &:before {
    content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1;
    transform: scale(0);
    transition: transform 0.3s ease;
    border-radius: 50%;
  }
`

export const LoaderRedirectIsOpen = css`
  top: 0;
  opacity: 1;

  &:before {
    transition: transform 0.3s linear;
    transform: scale(200);
  }
`

export const LoaderRedirectHolderActive = css`
  animation: ${SlideTop} 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
`

export const LoaderRedirectHolder = css`
  background-color: ${colors.white};
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 3px 19px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 2;

  ${above["l"]} {
    max-width: 498px;
    width: 100%;
    height: 275px;
  }
`

export const LoaderRedirectHeader = css`
  padding: 34px 10px 30px 10px;
  background-color: ${colorsCP["blue-40"]};
  height: 128px;
  justify-content: center;
  display: flex;
  align-items: center;
`

export const LoaderRedirectBall = css`
  width: 64px;
  height: 64px;
  background-color: ${colors.white};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const LoaderRedirectBar = css`
  width: 57px;
  height: 6px;
  background: linear-gradient(90deg, ${colorsCP["emerald-40"]}, ${colorsCP["blue-40"]});
  margin: 0 16px;
  border-radius: 6px;
  animation: ${AnimationBar} 1s linear infinite;
`

export const LoaderRedirectText = css`
  padding: 40px 20px;
  background-color: ${colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 147px;

  .iq-text {
    text-align: center;

    .product-themed & {
      color: ${colors.blue.default};
    }
  }

  .iq-text + .iq-text {
    margin-top: 16px;
    font-weight: 700;

    ${above["l"]} {
      margin-top: 30px;
    }
  }
`
